import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { get, flatten } from 'lodash';
import RouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';
import { Alert } from 'reactstrap';
import PropTypes from 'prop-types';

import { modelOf } from '../../../prop-types';
import PageTitle from '../../common/PageTitle';
import SEOTitle from '../../head/SEOTitle';
import AddressStore from '../../../store/AddressStore';
import UnexpectedError from '../../loader/UnexpectedError';
import AddressForm from '../../address/AddressForm';
import globalTranslations from '../../../i18n/globalTranslations';
import RouteService from '../../../services/RouteService';
import Paths from '../../../types/Paths';
import HelperNavigation from '../../common/HelperNavigation';
import RequestState from '../../../types/RequestState';

@observer
export class MyAccountAddressNew extends Component {
  state = {
    error: null,
    requestId: 0,
  };

  getBreadcrumbsPath = () => {
    const { intl, routeService } = this.props;
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.myAccount),
        url: Paths.MyAccount,
      },
      {
        text: intl.formatMessage(globalTranslations.addressBookTitle),
        url: Paths.MyAccountAddressList,
      },
      {
        text: intl.formatMessage(globalTranslations.addNewAddressTitle),
        url: Paths.MyAccountAddressNew,
      },
    ]);
  };

  saveAddress = (address) => {
    const { addressStore } = this.props;
    addressStore
      .saveAddress(address)
      .then(() => {
        this.navigateToAddressList();
      })
      .catch((error) =>
        this.setState({
          error: error,
          requestId: this.state.requestId + 1,
        })
      );
  };

  navigateToAddressList() {
    const { history, routeService } = this.props;
    history.push(routeService.getPath(Paths.MyAccountAddressList));
  }

  renderError = () => {
    const { error, requestId } = this.state;
    const status = get(error, 'response.status');
    return status === 422 ? (
      <Alert
        className="MyAccountAddressNew__errors"
        color="danger"
        key={requestId}
      >
        {flatten(Object.values(error.response.data)).map((message) => (
          <div key={message}>{message}</div>
        ))}
      </Alert>
    ) : (
      <UnexpectedError />
    );
  };

  render() {
    const { addressStore } = this.props;
    const { error } = this.state;

    return (
      <div className="MyAccountAddressNew">
        <SEOTitle title={globalTranslations.addNewAddressTitle} />
        <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
        <PageTitle>
          <FormattedMessage {...globalTranslations.addNewAddressTitle} />
        </PageTitle>
        {error && this.renderError()}
        <AddressForm
          onSubmit={this.saveAddress}
          loading={addressStore.state === RequestState.LOADING}
          buttonText={
            <FormattedMessage {...globalTranslations.addNewAddressTitle} />
          }
        />
      </div>
    );
  }
}

MyAccountAddressNew.propTypes = {
  addressStore: modelOf(AddressStore).isRequired,
  history: RouterPropTypes.history.isRequired,
  intl: intlShape.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
};

export default injectIntl(
  inject('addressStore', 'routeService')(withRouter(MyAccountAddressNew))
);
